// Organize PDF (FR-12): the page list being edited. Pure: no pdf-lib, so the
// page can use it without downloading the PDF library.

export type Rotation = 0 | 90 | 180 | 270;

/** One page of the result: which original page (0-based) and how much to
 *  turn it clockwise on top of its current rotation. */
export type PagePlan = { index: number; rotate: Rotation };

/** "2 pages deleted · 1 page turned · order changed" for the Save bar. */
export function describeChanges(pageCount: number, pages: PagePlan[]): string {
  const parts: string[] = [];
  const plural = (n: number, word: string) =>
    `${n} ${word}${n === 1 ? "" : "s"}`;
  const deleted = pageCount - pages.length;
  if (deleted > 0) parts.push(`${plural(deleted, "page")} deleted`);
  const turned = pages.filter((p) => p.rotate !== 0).length;
  if (turned > 0) parts.push(`${plural(turned, "page")} turned`);
  const order = pages.map((p) => p.index);
  if (order.some((v, i) => i > 0 && v < order[i - 1])) {
    parts.push("order changed");
  }
  return parts.length ? parts.join(" · ") : "No changes yet";
}
